import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { PrivateRoute, useSession } from 'gunsi-auth'
import { Home } from './pages/Home.jsx'
import { Dashboard } from './pages/Dashboard.jsx'
import { Groups } from './pages/Groups.jsx'
import { GroupDetail } from './pages/GroupDetail.jsx'
import { People } from './pages/People.jsx'
import { Activity } from './pages/Activity.jsx'
import { Converter } from './pages/Converter.jsx'
import { Settings } from './pages/Settings.jsx'

function LocaleSync() {
  const { session } = useSession()
  useEffect(() => {
    const lang = session?.user?.locale
    if (lang) {
      localStorage.setItem('lang-pref', lang)
      document.documentElement.lang = lang
    }
  }, [session?.user?.locale])
  return null
}

export default function App() {
  return (
    <>
      <LocaleSync />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard"  element={<Navigate to="/groups" replace />} />
          <Route path="/groups"     element={<Groups />} />
          <Route path="/groups/:id" element={<GroupDetail />} />
          <Route path="/people"     element={<People />} />
          <Route path="/activity"   element={<Activity />} />
          <Route path="/converter"  element={<Converter />} />
          <Route path="/settings"   element={<Settings />} />
        </Route>
      </Routes>
    </>
  )
}
